import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Loader } from '@altermaind/web/ui';
import { AlertBadge, GoBack, LayoutContext, Tabs } from '@/_shared/components';
import { useTabs } from '@/_shared/hooks';
import { getEmployerByIdCall } from '@/people/state/api/getEmployerByIdCall';
import { EmployeeProfile, EmployeeAssessment } from '../components';

export const DepartmentEmployeeDetailsScreen = () => {
  const t = useTranslations('department.details.tabs');
  const sharedT = useTranslations();
  const { setLayout } = useContext(LayoutContext);
  const [isEditing, setIsEditing] = useState(false);

  const { employeeId } = useParams();

  const {
    employer,
    success: successGetEmployerById,
    error: errorGetEmployerById,
    execute: executeGetEmployerById,
    loading: loadingGetEmployerById,
  } = getEmployerByIdCall.hook();

  const tabsInitialState = [
    {
      title: t('profile'),
      index: 0,
      active: true,
      dataTestId: 'profile',
    },
    {
      title: t('assessment'),
      index: 1,
      active: false,
      dataTestId: 'assessment',
    },
  ];

  const { tabs, setOpenTab } = useTabs({
    tabsInitialState,
  });

  useEffect(() => {
    if (employeeId) {
      executeGetEmployerById({ employeeId });
    }
  }, [employeeId, executeGetEmployerById]);

  useEffect(() => {
    setLayout({ title: 'department' });
  }, [setLayout, t]);

  return (
    <Box>
      <Box>
        <GoBack />
        {!isEditing ? <Tabs buttonVariant='primary' setActiveTab={setOpenTab} tabs={tabs} /> : null}
        <Box mt='s' />
        {loadingGetEmployerById && (
          <Box textAlign='center'>
            <Loader size='xxl' />
          </Box>
        )}
        {errorGetEmployerById && (
          <AlertBadge type='error' label={sharedT('errors.genericApiError')} />
        )}
        {successGetEmployerById &&
          employer &&
          tabs.map(tab => {
            return (
              <Box key={tab.title} display='flex' flexDirection='column'>
                {tab.index === 0 && tab.active && (
                  <EmployeeProfile employer={employer} onEditChange={setIsEditing} />
                )}
                {tab.index === 1 && tab.active && <EmployeeAssessment employer={employer} />}
              </Box>
            );
          })}
      </Box>
    </Box>
  );
};
